import { BreakingChangesDetail, ChangeType } from "./DesignUploadStep.types";
import { downloadFileByUrl } from "@/lib/utils";

export const getChangeLabel = (changeType: ChangeType): string => {
  const labels: Record<ChangeType, string> = {
    [ChangeType.GRATING_ADDED]: "Grating Added",
    [ChangeType.GRATING_REMOVED]: "Grating Removed",
    [ChangeType.GRATING_UPDATED]: "Grating Updated",
    [ChangeType.PAD_ADDED]: "Pad Added",
    [ChangeType.PAD_UPDATED]: "Pad Updated",
    [ChangeType.PAD_REMOVED]: "Pad Removed",
    [ChangeType.PORT_COMBO_ADDED]: "Port Combo Added",
    [ChangeType.PORT_COMBO_REMOVED]: "Port Combo Removed",
    [ChangeType.PORT_COMBO_UPDATED]: "Port Combo Updated",
    [ChangeType.STRUCTURE_ADDED]: "Structure Added",
    [ChangeType.STRUCTURE_NAME_CHANGED]: "Structure Name Changed",
    [ChangeType.STRUCTURE_REMOVED]: "Structure Removed",
  };
  return labels[changeType] || changeType;
};

export function downloadReport(detail: BreakingChangesDetail): void {
  const blob = new Blob([JSON.stringify(detail, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  downloadFileByUrl(url, "breaking-changes-report.json");
}

export const boolToString = (bool: boolean): string => {
  return bool ? "Yes" : "No";
};
